module.exports = __webpack_public_path__ + "img/header_fleet-min.9475aec5.jpg";